import cn from "classnames";
import BookForm from "components/shared/book/form";
import Loader from "components/shared/loader";
import { formatDateTimezone } from "helpers/bidpoint";
import { plainDate } from "helpers/date";
import { getInitialStateFromConfig, serializeReq, validateForm } from "helpers/form";
import { requiredField } from "helpers/validators";
import cloneDeep from "lodash/cloneDeep";
import pick from "lodash/pick";
import moment from "moment";
import React from "react";
import { setItemChangePointDates } from "sources/books/bids";

class ManualDatesForm extends BookForm {
    componentDidMount() {
        this.setState({ isLoading: false, ...this.props.initialState });
        this.props.setTitle("Ручное изменение дат въезда и выезда");
    }

    componentWillUnmount() {
        this.props.setTitle();
    }

    applyReq = (serialized) => {
        serialized = cloneDeep(serialized);
        serialized.manualStartAt = serialized.manualStartAt
            ? moment(serialized.manualStartAt).format("YYYY-MM-DDTHH:mm")
            : null;
        serialized.manualEndAt = serialized.manualEndAt
            ? moment(serialized.manualEndAt).format("YYYY-MM-DDTHH:mm")
            : null;
        return setItemChangePointDates(serialized).then((res) => {
            if (res) {
                this.close();
                this.props.getItem && this.props.getItem();
            } else {
                this.setState({ isLoading: false, isValid: false });
            }
        });
    };

    isValidForm = (state) => {
        const { config } = this.props;
        return validateForm(config, serializeReq(state));
    };

    setValue = ({ name, value }) => {
        const isValid = this.isValidForm({ ...this.state, [name]: value });
        this.setState({ [name]: value, ...(isValid ? { isValid: true } : {}) });
    };

    render() {
        const { config, initialData } = this.props;
        const { isValid, isLoading, manualEndAt } = this.state;
        if (isLoading) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="absolute-center" />
                </div>
            );
        }
        const cname = cn("book-form__body", { "book-form__body--invalid": !isValid });
        return (
            <form className={cname} onSubmit={this.onSubmit}>
                {this.renderDateField({
                    ...config.manualStartAt,
                    wrapper: "col-auto",
                    additionalText: formatDateTimezone({ planEnterDateOffset: initialData.manualStartAt }),
                    value: plainDate(this.state.manualStartAt),
                    ...(manualEndAt
                        ? {
                              required: true,
                              validators: [requiredField],
                          }
                        : {}),
                })}
                {this.renderDateField({
                    ...config.manualEndAt,
                    wrapper: "col-auto",
                    additionalText: formatDateTimezone({ planEnterDateOffset: initialData.manualEndAt }),
                    value: plainDate(this.state.manualEndAt),
                })}
                <div className="mt-3 float-right">
                    <div className="btn btn-sm btn-secondary mr-2" onClick={this.props.back}>
                        Отмена
                    </div>
                    <input type="submit" className="btn btn-sm btn-brand" value="Сохранить" />
                </div>
            </form>
        );
    }
}

const ConfiguredForm = (props) => {
    const initialData = pick(props.item, Object.keys(config));
    return (
        <ManualDatesForm
            {...props}
            config={config}
            initialState={{ ...initialState, ...initialData }}
            initialData={initialData}
        />
    );
};

const config = {
    manualStartAt: {
        label: "Дата въезда",
        inPortal: true,
        inputProps: { name: "manualStartAt" },
        validators: [(value, data) => (data.manualEndAt ? requiredField(value) : "")],
    },
    manualEndAt: {
        label: "Дата выезда",
        inPortal: true,
        inputProps: { name: "manualEndAt" },
    },
    id: {},
    bidId: {},
};

const initialState = getInitialStateFromConfig(config);

export default ConfiguredForm;
